import React, { useState } from 'react';
import { supabase } from '../lib/supabase';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { getClaims } from '../lib/jwt';
import { TENANT_SLUG } from '../lib/tenant';
import '../styles/Login.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      console.log('Attempting login with:', { email });
      
      const { data, error } = await supabase.auth.signInWithPassword({
        email,
        password,
      });

      if (error) {
        console.error('Login error:', error);
        throw error;
      }

      console.log('Login successful:', data);
      toast.success('Successfully logged in');
      const claims = await getClaims();
      // On a tenant subdomain, send everyone to that tenant's admin (super_admin
       // can still edit). The system-wide /super-admin panel lives on the apex.
      const isSuperOnApex = claims?.app_role === 'super_admin' && !TENANT_SLUG;
      navigate(isSuperOnApex ? '/super-admin' : '/admin/products');
    } catch (error: any) {
      console.error('Login error:', error);
      toast.error(error.message || 'Error logging in');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-wrap">
        <div className="login-brand">★ SERBIA SHOP</div>
        <div className="login-card">
          <h2>Dobrodošli nazad</h2>
          <p className="login-sub">Prijavite se da upravljate svojom prodavnicom</p>
          <form onSubmit={handleLogin}>
            <div>
              <label>Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="vase.ime@example.com"
                required
                disabled={loading}
                autoFocus
              />
            </div>
            <div>
              <label>Lozinka</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                disabled={loading}
              />
            </div>
            <button type="submit" disabled={loading}>
              {loading ? 'Prijavljujem...' : 'Prijavi se'}
            </button>
          </form>
          <div className="login-footer">
            Nemate nalog? <Link to="/register">Registrujte se</Link>
          </div>
        </div>
        <Link to="/" className="login-back">← Nazad na početnu</Link>
      </div>
    </div>
  );
};

export default Login; 